// extracted by mini-css-extract-plugin
export default {"customButton":"Button_customButton__QOlqW","customButton_disabled":"Button_customButton_disabled__zYYbR"};